export default {
    bk_page_carrier: "bk-page-carrier",
    bk_page_shipper: "bk-page-shipper",
    bk_page_top_shipper: "bk-page-top-shipper",
    bk_page_fuel: "bk-page-fuel",
    bk_request_success: "bk-request-success",
    bk_enter_amount: "bk-enter-amount",
    bk_enter_email: "bk-enter-email",
    bk_get_prepayment: "bk-get-prepayment",
    BridgeCapitalLoansCarrierLanding: "BridgeCapitalLoansCarrierLanding", // Перевозчик
    BridgeCapitalLoansForwarderLanding: "BridgeCapitalLoansForwarderLanding", // Экспедитор
    BridgeCapitalLoansTopForwarderLanding: "BridgeCapitalLoansTopForwarderLanding", // ТОП-Экспедитор
    BridgeCapitalLoansFuelLanding: "BridgeCapitalLoansFuelLanding", // Топливо
    product: "BridgeCapitalLoans",
};
